import angular from 'angular';
import template from './quality-notification.html';
class Controller {
    constructor($rootScope, $timeout) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.isActive = false;
        const TOOLTIP_TIMEOUT_SECONDS = 5;
        if (this.$rootScope.videoQualityNotification) {
            this.isActive = true;
            this.hideInSec(TOOLTIP_TIMEOUT_SECONDS);
        }
        this.message = this.$rootScope.videoQualityNotification;
    }
    hide() {
        this.message = '';
        this.isActive = false;
    }
    hideInSec(sec) {
        this.$timeout(() => {
            this.isActive = false;
        }, sec * 1000);
    }
}
const component = {
    template,
    bindings: {
        isActive: '=',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callActions.callActionsQualityNotification', [])
    .component('callActionsQualityNotification', component).name;
